import { Component } from '@angular/core';
import { navigation } from '../../../config/navigationLinks.const';
import { NavigationLinkCategory } from '../../../models/navigation-link';

@Component({
    selector: 'app-order-product-not-found-view',
    templateUrl: './order-product-not-found-view.component.html',
    styleUrls: ['./order-product-not-found-view.component.scss'],
    standalone: false,
})
export class OrderProductNotFoundViewComponent {
    public links: NavigationLinkCategory[] = [...navigation];
}
